import React, { Component } from 'react';

import ResetPasswordForm from 'auth/ResetPasswordForm';
import RequestResetCodeForm from 'auth/RequestResetCodeForm';

import Warning from 'notifications/Warning';
import Info from 'notifications/Info';

export class ResetPassword extends Component {
  state = {
    resetCodeSent: false
  }

  onResetCodeSent = () => {
    this.setState({
      resetCodeSent: true
    });
  }

  render() {
    return (
      <div className="ResetPassword">
        <h1>Set a New Password</h1>
        {!this.state.resetCodeSent &&
          <RequestResetCodeForm onSubmitSuccess={this.onResetCodeSent} />
        }
        <Info name="requestResetCode" />
        {this.state.resetCodeSent &&
          <ResetPasswordForm />
        }
        <Warning name="requestResetCode" />
        <Warning name="resetPassword" />
      </div>
    );
  }
}

export default ResetPassword;
